
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../components/base/Button';

export const TravelPhilosophySection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          {/* <Link to="/experience" aria-label="Experience — explore experiences">
            <Button variant="outline" className="mb-8">
              <i className="ri-compass-3-line w-5 h-5 flex items-center justify-center"></i>
              Experience
            </Button>
          </Link> */}

          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Traveling Since 2013...!
          </h2>

          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p className="italic" style={{ fontFamily: "'Playfair Display', serif" }}>
              Travel better. Travel deeper. Travel with Prime Meridian.
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="text-emerald-600 text-3xl mb-3">🧭</div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">Renovate your mind</h4>
                <p className="text-gray-700 text-sm">Renovate your mind. Map your journeys. Reconnect with the world. At Prime Meridian, we curate the world's finest itineraries for passionate travelers who never settle for less than extraordinary.</p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="text-emerald-600 text-3xl mb-3">🌍</div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">Why travelers choose us</h4>
                <p className="text-gray-700 text-sm">Why do travelers choose us? Because like them, we believe travel should be more than just a trip — it should be a transformative experience.</p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="text-emerald-600 text-3xl mb-3">✨</div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">Personalized tours</h4>
                <p className="text-gray-700 text-sm">Our personalized tours are crafted with one goal: to immerse you in the beauty, culture, and magic of every destination.</p>
              </div>
            </div>

            
          </div>

          <div className="mt-12 max-w-5xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed">
              For over a decade, Prime Meridian Travel Co. has established itself as a trusted name in the global travel and tourism industry, specializing in tailor-made itineraries for destinations worldwide. Our mission is to offer unique, off-beat travel experiences by maintaining innovative concepts across all our travel products. We are committed to delivering top-quality service to every type of traveler, expanding regional exploration to include the widest range of itineraries possible. Staying ahead with the latest travel trends, we ensure that our dedicated team is available 24/7 to meet your travel needs. At Prime Meridian, we craft personalized journeys designed around your preferences, making every trip truly unforgettable.
            </p>
          </div>

          <div className="mt-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
              "Become an adventurer. Travel eco-friendly. Embrace nature. Be a responsible traveler."
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};
